export function includeIf<T>(condition: boolean | undefined, ...items: T[]) {
  return condition ? items : [];
}

export const moveIndexFirst = <T>(items: T[], index: number): T[] => {
  return index !== -1 && items.length !== 0 && index < items.length
    ? [items[index], ...items.slice(0, index), ...items.slice(index + 1)]
    : items;
};
